import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import debounce from 'lodash/debounce';
import classNames from 'classnames';
import WidgetBase from 'components/manager-dashboard/WidgetBase';
import UserStore from 'stores/UserStore';
import UserActions from 'actions/UserActions';
import './SuggestedActions.styl';
import AuthStore from 'stores/AuthStore';
import {DialogBubble} from 'components/pure/tooltips/CallToAction';
import GenericTooltip from 'components/pure/tooltips/GenericTooltip';
import MetricTooltip from 'components/pure/tooltips/MetricTooltip';
import SuggestedAction from 'components/dashboard/SuggestedAction';
import {TOOLTIP_DELAY} from 'components/StatsPage2.utils';

const recommendedCoachingTooltip = (
  <MetricTooltip
    header="Recommended Coaching"
    tooltip="Coach recommends the following Coaching Plans using a proprietary algorithm that identifies which reps have the most potential to improve and the skill that needs the most focus. Use the buttons below to create a Coaching Plan in only 2 clicks."
    link="https://support.mediafly.com/hc/en-us/articles/13547960731163-Manager-Dashboard#h_01GVDJEB0JZB1A9V0C21HZREQX"
  />
);

@connectToStores
export default class SuggestedActions extends WidgetBase {
  constructor(props) {
    super(props);

    this.debouncedGetUsers = debounce(() => {
      this.getUsers();
    }, 300);

    this.state = {
      showHeaderTooltip: false,
      bubbleDismissed: false,
    };
  }

  static getStores() {
    return [UserStore, AuthStore];
  }

  static getPropsFromStores() {
    return {
      storedUsers: UserStore.getState().users,
      sessionUser: AuthStore.getState().user,
    };
  }

  componentDidMount() {
    this.debouncedGetUsers();
    const {listColumn, recommendations} = this.props;

    if (listColumn && recommendations && recommendations.length > 0) {
      this.setState({
        ...this.state,
        showHeaderTooltip: true,
      });
    }
  }

  componentDidUpdate() {
    this.debouncedGetUsers();
  }

  getUsers() {
    const ids = this.props.recommendations.map(it => it.first);
    const idsWithNoUsers = [];
    const storedUsers = this.props.storedUsers;
    ids.forEach(id => {
      if (!storedUsers.get(id)) {
        idsWithNoUsers.push(id);
      }
    });
    if (idsWithNoUsers.length > 0) {
      UserActions.fetchAll.defer({ids: idsWithNoUsers});
    }
  }

  render() {
    const {sessionUser, recommendations, storedUsers, numActionsShown, suppressMascotCta} =
      this.props;
    const {showHeaderTooltip} = this.state;
    const topN =
      recommendations && recommendations.length > 0
        ? recommendations.filter(it => !!storedUsers.get(it.first)).slice(0, numActionsShown)
        : [];
    const shouldShowPopover = topN.length === 0 && !suppressMascotCta;
    const title = this.props.title ? this.props.title : 'Suggested Actions';
    const listColumnClass = this.props.listColumn ? 'list-column' : '';
    const widgetClass = classNames('widget', 'suggested-actions', listColumnClass);
    const listClass = classNames('actions-list', listColumnClass);
    const titleClass = classNames('widget-title', 'actions-title', listColumnClass, 'nowrap');
    const titleAndDateClass = classNames('title-and-dates', listColumnClass);
    const mascotAnchorClass = classNames('mascot-anchor', listColumnClass);
    const nothingYetClass = classNames('nothing-yet', listColumnClass);
    const actionClass = classNames('suggested-action', listColumnClass);

    const header = (
      <div className={titleAndDateClass}>
        <div className={titleClass}>
          <h3>{title}</h3>
        </div>
      </div>
    );

    return (
      <div className={widgetClass}>
        <header
          className="widget-head"
          onMouseEnter={this.props.onMouseEnter}
          onMouseLeave={this.props.onMouseLeave}>
          {showHeaderTooltip ? (
            <GenericTooltip
              positionTop
              delay={TOOLTIP_DELAY}
              className={'suggested-actions-tooltip-popover'}
              tooltip={recommendedCoachingTooltip}>
              {header}
            </GenericTooltip>
          ) : (
            header
          )}
          <div>
            <div className={mascotAnchorClass} />
            <div className={'mascot-wrapper'}>
              {shouldShowPopover && !this.state.bubbleDismissed && (
                <div className="suggested-actions-mascot-message">
                  <DialogBubble
                    orientation="left"
                    dismissible
                    onDismiss={() => this.setState({...this.state, bubbleDismissed: true})}
                    text="We’ll add recommendations as you proceed with your coaching
              sessions."
                  />
                </div>
              )}
            </div>
          </div>
        </header>
        <div className={listClass}>
          {topN.length === 0 ? (
            <div className={nothingYetClass}>
              We don't have any recommendations for you yet. As your team receives more scoring we
              will generate recommendations for you. (Reps who already have coaching plans won't
              appear here.)
            </div>
          ) : (
            topN.map(rec => {
              const user = storedUsers.get(rec.first);
              return (
                <SuggestedAction
                  className={actionClass}
                  user={user}
                  recommendation={rec.second}
                  sessionUser={sessionUser}
                />
              );
            })
          )}
        </div>
      </div>
    );
  }
}
